import { useQuery, type UseQueryOptions } from '@tanstack/react-query';

import { axiosInt, API_CORE_URL } from '../../../utils';
import type { ICursorPaginateData, IBaseTableParams } from '../../../types';

export interface IModelInstanceParams extends IBaseTableParams {
  modelIds?: string[];
  modelInstanceIds?: string[];
  filters?: string;
}

export const FETCH_MODEL_INSTANCES_CURSOR_PAGINATION_KEY =
  'fetchModelInstancesCursorPagination';
export const fetchModelInstancesCursorPaginationApi = async (
  params?: IModelInstanceParams
): Promise<ICursorPaginateData<any>> => {
  const response = await axiosInt.get(
    `${API_CORE_URL}/model-instances/cursor-pagination`,
    {
      params,
    }
  );
  return response.data;
};

const useFetchModelInstancesCursorPagination = ({
  params,
  options,
}: {
  params?: IModelInstanceParams;
  options?: Partial<UseQueryOptions<ICursorPaginateData<any>>>;
} = {}) => {
  const {
    data: modelInstances,
    isFetching: isLoadingModelInstances,
    isLoading: isFirstLoadingModelInstaces,
    error: errorFetchingModelInstances,
  } = useQuery<ICursorPaginateData<any>>({
    queryKey: [FETCH_MODEL_INSTANCES_CURSOR_PAGINATION_KEY, params],
    queryFn: () => fetchModelInstancesCursorPaginationApi(params),
    ...options,
  });

  return {
    modelInstances,
    isLoadingModelInstances,
    isFirstLoadingModelInstaces,
    errorFetchingModelInstances,
  };
};

export default useFetchModelInstancesCursorPagination;
